import Theme from "./MenuClassement/theme/theme";
import Canal from "./MenuClassement/canal/canal";
import AddEditCanal from "./MenuClassement/canal/components/AddEdit/addEdit";
import AddEditTheme from "./MenuClassement/theme/components/AddEdit/addEdit";
import { Routes, Route} from "react-router-dom";
import PagenotFound from './MenuClassement/pagenotfound/404notFound'
import "./customFont.css"
import { useEffect } from "react";
import { applyThemeMode, getSavedThemeMode, normalizeThemeMode, saveThemeMode } from "./utils/theme";
import { getSafeColor } from "./utils/color";
function App() {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const safeColor = getSafeColor(queryParams.get("color"));

    if (safeColor) {
      document.documentElement.style.setProperty('--primary-color', safeColor);
      document.body.classList.add('custom-theme');
    } else {
      document.documentElement.style.removeProperty('--primary-color');
      document.body.classList.remove('custom-theme');
    }
  }, []);

    useEffect(() => {
    const handleThemeMessage = (event : any) => {
        if (event.data && event.data.info === 'updateTheme') {
            const theme = normalizeThemeMode(event.data.theme);
            applyThemeMode(theme);
            saveThemeMode(theme);
        }
    };

    window.addEventListener('message', handleThemeMessage);
    applyThemeMode(getSavedThemeMode());

    return () => {
        window.removeEventListener('message', handleThemeMessage);
    };
}, []);
    return (
        <div className="App">
             <Routes>
        <Route path="/classement/themes" element={<Theme />} />
        <Route path="/classement/channels" element={<Canal />} />
        <Route path="/classement/channel/:id/:action" element={<AddEditCanal />} />
        <Route path="/classement/Theme/:id/:action" element={<AddEditTheme />} />
        <Route path="/classement/*" element={<PagenotFound />} />
        </Routes>
        </div>
    );
}

export default App;
